var app = angular.module('app-cart', ['app-cart-service']);


app.controller('Cart', ['$scope', '$http', '$window', '$sce', 'cartService', function ($scope, $http, $window, $sce, cartService) {
    $scope.Cart = {};
    $scope.isCartSummaryOpen = false;
    $scope.culture = $window.culture;

    $scope.getCartSummary = function (fromCache) {
        if (fromCache) {
            $scope.Cart = cartService._cartSummary;
        } else {
            cartService.getCartSummary().then(function () {
                $scope.Cart = cartService._cartSummary;
            })
        }
    }

    $scope.updateCartItem = function (item, quantity) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/updatecartitem' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '')
            $http({
                method: 'POST',
                url: url,
                cache: false,
                withCredentials: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: { partnumberCode: item.Product.Partnumber.Code, modelId: item.Product.Id, productType: item.Product.ProductTypeId, quantity: quantity, SupplementaryItemPartnumberCode: (item.SupplementaryItemPartnumberCode != null ? item.SupplementaryItemPartnumberCode : '') },
            }).then(function (res) {
                $scope.Cart = res.data;
            });
        });
    }

    $scope.removeCartItem = function (item) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecartitem/' + item.Id + '/json?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '') + (item.SupplementaryItemPartnumberCode != null ? '&SupplementaryItemPartnumberCode=' + item.SupplementaryItemPartnumberCode : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.Cart = res.data;
                AnalyticsBuilder.create(window.inTestMode ? { debug: true } : {}).addProduct({
                    'id': item.Product.Partnumber != undefined ? item.Product.Partnumber.Code : '',
                    'name': item.Product.Name,
                    'quantity': item.Quantity
                }).asRemoveFromCart({
                    'id': item.Product.Partnumber != undefined ? item.Product.Partnumber.Code : '',
                    'name': item.Product.Name,
                    'quantity': item.Quantity
                }).send();
            });
        });
    }

    $scope.$on('cartUpdated', function () {
        $scope.isCartSummaryOpen = false;
        $scope.getCartSummary();
    });

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $scope.$watch(function () { return $scope.isCartSummaryOpen && $scope.Cart.CartItems.length > 0 }, function () {
        //A360: set focus to button and set tab index to -1 for all other items outside modal window
        if ($scope.isCartSummaryOpen && $scope.Cart.CartItems.length > 0) {
            setTimeout(
                function () {
                    document.getElementById('proceedToCheckoutButton').focus();
                    openDialog($('.summary-popup')[0]);
                }, 10);

            //A360 if escape button pressed and cart summary is open => close it.
            $("body").on("keydown", function (e) {
                if (e.key === "Escape") { // escape key maps to keycode `27`
                    $scope.isCartSummaryOpen = false;
                    $scope.$apply();
                }
            });
        } else if ($scope.Cart != undefined && $scope.Cart.CartItems != undefined) {
            setTimeout(
                function () {
                    closeDialog();
                    document.getElementById('cart-summary-container2').focus();
                }, 10);

            //A360 if escape button pressed and cart summary is open => close it.
            $("body").off("keydown");
        }
    });
}]);

angular.element(document).ready(function () {
    try {
        var appID = document.getElementById('app-cart');
        angular.bootstrap(appID, ['app-cart']);
    } catch (e) {
        //do nothing
    }
});